import { render } from "./BaseIconSvg.vue?vue&type=template&id=908b7b70&scoped=true"
import script from "./BaseIconSvg.vue?vue&type=script&lang=js"
export * from "./BaseIconSvg.vue?vue&type=script&lang=js"

import "./BaseIconSvg.vue?vue&type=style&index=0&id=908b7b70&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908b7b70"]])

export default __exports__